import { Box, Typography, Paper, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useParentApp } from '@/shared/hooks/useParentApp';

/**
 * AuthErrorPage Component
 *
 * Displayed when authentication fails or no valid token is found.
 * Users are directed to access the app via the parent app deeplink.
 */
export function AuthErrorPage() {
  const { isInsideIframe, navigateToRockease } = useParentApp();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 80, color: 'error.main', mb: 3 }} />

        <Typography variant="h5" gutterBottom color="error.main" fontWeight="bold">
          Authentification échouée
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mt: 2, mb: 3 }}>
          Impossible d'accéder à l'application. Veuillez vous assurer d'accéder à cette application
          via le lien fourni par l'application parent.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          L'accès direct à cette application n'est pas autorisé. Vous devez utiliser le lien
          d'authentification fourni par l'application principale.
        </Typography>

        {isInsideIframe && (
          <Button
            variant="contained"
            startIcon={<ChevronLeftIcon />}
            onClick={navigateToRockease}
            data-testid="auth-error-back-to-parent"
            sx={{ mt: 3 }}
          >
            Retour
          </Button>
        )}
      </Paper>

      <Typography variant="caption" color="text.secondary" sx={{ mt: 4 }}>
        ROCKEASE Bourse aux Matériaux
      </Typography>
    </Box>
  );
}
